import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { debugId, toDebugString } from "../debug";
import { evaluateConditions } from "./evaluateConditions";
import { getEndpointHeaders } from "./getEndpointHeaders";
import { getEndpointProperties } from "./getEndpointProperties";
import { getEndpointUrl } from "./getEndpointUrl";
export var evaluateEndpointRule = function evaluateEndpointRule(endpointRule, options) {
  var _options$logger, _options$logger$debug;
  var conditions = endpointRule.conditions,
    endpoint = endpointRule.endpoint;
  var _evaluateConditions = evaluateConditions(conditions, options),
    result = _evaluateConditions.result,
    referenceRecord = _evaluateConditions.referenceRecord;
  if (!result) {
    return;
  }
  var endpointRuleOptions = _objectSpread(_objectSpread({}, options), {}, {
    referenceRecord: _objectSpread(_objectSpread({}, options.referenceRecord), referenceRecord)
  });
  var url = endpoint.url,
    properties = endpoint.properties,
    headers = endpoint.headers;
  (_options$logger = options.logger) === null || _options$logger === void 0 ? void 0 : (_options$logger$debug = _options$logger.debug) === null || _options$logger$debug === void 0 ? void 0 : _options$logger$debug.call(_options$logger, "".concat(debugId, " Resolving endpoint from template: ").concat(toDebugString(endpoint)));
  return _objectSpread(_objectSpread(_objectSpread({}, headers != undefined && {
    headers: getEndpointHeaders(headers, endpointRuleOptions)
  }), properties != undefined && {
    properties: getEndpointProperties(properties, endpointRuleOptions)
  }), {}, {
    url: getEndpointUrl(url, endpointRuleOptions)
  });
};